import React, { useState, useEffect } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Hitungan Mundur Ulang Tahun - Berapa Lama Lagi hingga Ulang Tahun Saya";
const DESCRIPTION =
  "Hitung dengan tepat berapa lama lagi hingga ulang tahun Anda! Kalkulator hitungan mundur ulang tahun menampilkan sisa waktu dalam bulan, hari, jam, menit, dan detik. Temukan kapan ulang tahun Anda berikutnya dan bersiaplah untuk merayakannya";
const KEYWORDS =
  "berapa lama lagi hingga ulang tahun saya, kalkulator ulang tahun, hitungan mundur ulang tahun, menghitung sisa waktu hingga ulang tahun, kapan ulang tahun saya, menghitung ulang tahun saya berikutnya, sisa waktu hingga ulang tahun, penghitung ulang tahun";
const OG_URL = "https://do-calculate.com/calculator/id/birthday/";
// JSON-LD Schema for SEO
const SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "Kalkulator Hitungan Mundur Ulang Tahun",
    description: DESCRIPTION,
    url: OG_URL,
    applicationCategory: "UtilityApplication",
    operatingSystem: "Any",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Beranda",
        item: "https://do-calculate.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Kalkulator",
        item: "https://do-calculate.com/id/all-calculators/",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Kalkulator Ulang Tahun",
        item: OG_URL,
      },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "Bagaimana cara mengetahui berapa lama lagi hingga ulang tahun saya?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Masukkan tanggal lahir Anda ke dalam kalkulator dan Anda akan segera mendapatkan hitungan mundur yang akurat untuk ulang tahun Anda berikutnya dalam bulan, hari, jam, menit, dan detik.",
        },
      },
      {
        "@type": "Question",
        name: "Apakah penghitung diperbarui secara otomatis?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Ya, penghitung diperbarui secara otomatis setiap detik untuk menampilkan sisa waktu dengan sangat akurat hingga saat ulang tahun Anda.",
        },
      },
    ],
  },
];

const GREGORIAN_MONTHS = [
  "Januari", "Februari", "Maret", "April",
  "Mei", "Juni", "Juli", "Agustus",
  "September", "Oktober", "November", "Desember"
];

const DAYS_OF_WEEK = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];


function AgeCalculatorGregorian() {
  // 1. Define state for dropdowns
  const [birthDateInput, setBirthDateInput] = useState({
    day: "1",
    month: "1",
    year: "1990"
  });

  const [countdown, setCountdown] = useState(null);
  const [error, setError] = useState(null);
  const [isToday, setIsToday] = useState(false);

  // 2. Modify calculation function to use values from dropdowns
  const calculateCountdown = () => {
    // Compose date from selections
    const selectedDate = new Date(
      parseInt(birthDateInput.year),
      parseInt(birthDateInput.month) - 1, // Months in JS start from 0
      parseInt(birthDateInput.day)
    );

    if (isNaN(selectedDate.getTime())) {
      setError("Tanggal tidak valid. Harap periksa hari (misalnya 31 Februari tidak ada)");
      setCountdown(null);
      return;
    }

    updateCountdown(selectedDate);
  };

  const updateCountdown = (birthDate) => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const birthMonth = birthDate.getMonth();
    const birthDay = birthDate.getDate();

    let nextBirthday = new Date(currentYear, birthMonth, birthDay);
    if (nextBirthday < currentDate) {
      nextBirthday.setFullYear(currentYear + 1);
    }

    const today = new Date();
    const isBirthdayToday = today.getDate() === birthDay && today.getMonth() === birthMonth;
    setIsToday(isBirthdayToday);

    if (isBirthdayToday) {
      setCountdown({
        isBirthday: true,
        nextBirthdayDate: nextBirthday.toLocaleDateString("id-ID", { weekday: "long", year: "numeric", month: "long", day: "numeric" }),
        dayOfWeek: DAYS_OF_WEEK[nextBirthday.getDay()],
        age: currentYear - birthDate.getFullYear(),
      });
      setError(null);
      return;
    }

    const remainingTime = nextBirthday - currentDate;
    const totalSeconds = Math.floor(remainingTime / 1000);
    const totalMinutes = Math.floor(totalSeconds / 60);
    const totalHours = Math.floor(totalMinutes / 60);
    const totalDays = Math.floor(totalHours / 24);

    let months = nextBirthday.getMonth() - currentDate.getMonth();
    let days = nextBirthday.getDate() - currentDate.getDate();
    if (days < 0) {
      months--;
      const lastMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
      days += lastMonth.getDate();
    }
    if (months < 0) months += 12;

    setCountdown({
      isBirthday: false,
      months, days,
      hours: totalHours % 24,
      minutes: totalMinutes % 60,
      seconds: totalSeconds % 60,
      totalDays, totalHours, totalMinutes, totalSeconds,
      nextBirthdayDate: nextBirthday.toLocaleDateString("id-ID", { weekday: "long", year: "numeric", month: "long", day: "numeric" }),
      dayOfWeek: DAYS_OF_WEEK[nextBirthday.getDay()],
      ageOnNextBirthday: nextBirthday.getFullYear() - birthDate.getFullYear(),
      weeksRemaining: Math.floor(totalDays / 7),
    });
    setError(null);
  };

  // 3. Update useEffect to monitor selected date
  useEffect(() => {
    let interval;
    if (countdown && !countdown.isBirthday) {
      const selectedDate = new Date(
        parseInt(birthDateInput.year),
        parseInt(birthDateInput.month) - 1,
        parseInt(birthDateInput.day)
      );
      interval = setInterval(() => {
        updateCountdown(selectedDate);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [birthDateInput, countdown]);
  return (
    <div className="ltr" >
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        SCHEMA={SCHEMA}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ padding: "15px", borderRadius: "5px" }}
          >
            <h1 style={{ fontSize: "22px", margin: 0 }}>
              Kalkulator Hitungan Mundur Ulang Tahun
            </h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            {/* Introduction */}
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                <strong>Kalkulator Hitungan Mundur Ulang Tahun</strong> membantu Anda
                mengetahui dengan tepat sisa waktu hingga ulang tahun Anda berikutnya! Masukkan tanggal
                lahir Anda dan dapatkan penghitung mundur akurat yang menampilkan bulan, hari, jam,
                menit, dan detik yang tersisa. Bersiaplah untuk merayakan hari istimewa Anda dan ketahui
                kapan harus memulai persiapan!
              </p>
            </div>
            <hr />
            <MobileUnderCalAds />
            {/* Calculator Section */}
            <div className="calculatorStyle mb-4">
              <div className="p-3 mb-3 bg-success text-white text-center rounded">
                <h2 style={{ fontSize: "18px", margin: 0 }}>
                  Temukan Berapa Lama Lagi hingga Ulang Tahun Anda
                </h2>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <label ><strong>Masukkan Tanggal Lahir Anda:</strong></label>
                  <div className="d-flex gap-2 flex-wrap">
                    {/* Day */}
                    <select
                      className="form-control flex-grow-1"
                      value={birthDateInput.day}
                      onChange={(e) => setBirthDateInput({ ...birthDateInput, day: e.target.value })}
                    >
                      {Array.from({ length: 31 }, (_, i) => i + 1).map(d => (
                        <option key={d} value={d}>{d}</option>
                      ))}
                    </select>

                    {/* Month */}
                    <select
                      className="form-control flex-grow-1"
                      value={birthDateInput.month}
                      onChange={(e) => setBirthDateInput({ ...birthDateInput, month: e.target.value })}
                    >
                      {GREGORIAN_MONTHS.map((m, i) => (
                        <option key={i + 1} value={i + 1}>{i + 1} - {m}</option>
                      ))}
                    </select>

                    {/* Year */}
                    <select
                      className="form-control flex-grow-1"
                      value={birthDateInput.year}
                      onChange={(e) => setBirthDateInput({ ...birthDateInput, year: e.target.value })}
                    >
                      {Array.from({ length: 100 }, (_, i) => new Date().getFullYear() - i).map(y => (
                        <option key={y} value={y}>{y}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <br />
              <div className="text-center mb-3 mt-4">
                <button
                  className="btn btn-success btn-lg"
                  style={{ fontSize: "18px", padding: "10px 40px" }}
                  onClick={calculateCountdown}
                >
                  Mulai Hitungan Mundur
                </button>
              </div>
              {error && (
                <div className="alert alert-warning" role="alert">
                  <strong>Peringatan:</strong> {error}
                </div>
              )}
              {countdown && countdown.isBirthday && (
                <div
                  className="alert alert-success text-center"
                  style={{ fontSize: "18px" }}
                >
                  <h3 style={{ fontSize: "24px", marginBottom: "15px" }}>
                    🎉 Selamat Ulang Tahun! 🎂
                  </h3>
                  <p style={{ fontSize: "20px" }}>
                    Hari ini adalah ulang tahun Anda! Tahun baru Anda yang ke {countdown.age}
                  </p>
                  <p style={{ fontSize: "16px" }}>
                    Ulang tahun Anda berikutnya akan jatuh pada: {countdown.nextBirthdayDate}
                  </p>
                </div>
              )}
              {countdown && !countdown.isBirthday && (
                <div className="alert alert-info" style={{ fontSize: "16px" }}>
                  <h3
                    style={{
                      fontSize: "20px",
                      marginBottom: "20px",
                      textAlign: "center",
                    }}
                  >
                    <strong>⏰ Hitungan Mundur Menuju Ulang Tahun Anda</strong>
                  </h3>
                  <div
                    className="p-4 mb-3 bg-light rounded text-center"
                    style={{
                      fontSize: "24px",
                      fontWeight: "bold",
                      color: "#155724",
                    }}
                  >
                    {countdown.months > 0 && (
                      <span>
                        {countdown.months} bulan{" "}
                      </span>
                    )}
                    {countdown.days} hari {countdown.hours} jam
                    <br /> {countdown.minutes} menit {countdown.seconds}{" "}
                    detik
                  </div>
                  <div className="info-sections-container">
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>Informasi Detail tentang Ulang Tahun Anda Berikutnya</strong>
                      </div>
                      <div className="info-section-body">
                        <ul style={{ listStyle: "none", padding: 0 }}>
                          <li>
                            📅 <strong>Tanggal:</strong>{" "}
                            {countdown.nextBirthdayDate}
                          </li>
                          <li>
                            📆 <strong>Hari:</strong> {countdown.dayOfWeek}
                          </li>
                          <li>
                            🎂 <strong>Anda akan berusia:</strong>{" "}
                            {countdown.ageOnNextBirthday} tahun
                          </li>
                          <li>
                            ⏱️ <strong>Sisa Hari:</strong>{" "}
                            {countdown.totalDays} hari
                          </li>
                          <li>
                            📊 <strong>Sisa Minggu:</strong>{" "}
                            {countdown.weeksRemaining} minggu
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>Statistik Tambahan</strong>
                      </div>
                      <div className="info-section-body">
                        <ul style={{ listStyle: "none", padding: 0 }}>
                          <li>
                            ⏰ Total Jam Tersisa:{" "}
                            {countdown.totalHours.toLocaleString()} jam
                          </li>
                          <li>
                            ⏰ Total Menit Tersisa:{" "}
                            {countdown.totalMinutes.toLocaleString()} menit
                          </li>
                          <li>
                            ⏰ Total Detik Tersisa:{" "}
                            {countdown.totalSeconds.toLocaleString()} detik
                          </li>
                          <li>
                            📈 Persentase Waktu Tersisa dari Tahun Ini:{" "}
                            {countdown.yearProgress}%
                          </li>
                        </ul>
                        <div
                          className="alert alert-success mt-3"
                          style={{ fontSize: "14px" }}
                        >
                          <strong>💡 Tips:</strong> Simpan halaman ini di
                          favorit untuk memantau hitungan mundur kapan saja!
                        </div>
                      </div>
                    </div>
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>Ide untuk Merayakan Ulang Tahun Anda</strong>
                      </div>
                      <div className="info-section-body">
                        <p style={{ lineHeight: "1.8" }}>
                          Menjelang ulang tahun Anda, berikut beberapa ide untuk merayakannya:
                        </p>
                        <ul style={{ lineHeight: "1.8" }}>
                          <li>🎈 Adakan pesta bersama keluarga dan teman</li>
                          <li>🎁 Siapkan daftar hadiah favorit</li>
                          <li>🍰 Pesan kue ulang tahun yang istimewa</li>
                          <li>📸 Rencanakan sesi foto kenangan</li>
                          <li>✈️ Rencanakan perjalanan singkat atau aktivitas khusus</li>
                          <li>💌 Kirim undangan kepada orang terkasih</li>
                          <li>🎉 Siapkan dekorasi dan suasana meriah</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <hr />
            {/* Related Links */}
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>
      {/* Informational Content */}
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <strong>Apa Itu Kalkulator Hitungan Mundur Ulang Tahun?</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Kalkulator Hitungan Mundur Ulang Tahun</strong> adalah alat
                  elektronik canggih yang membantu Anda mengetahui dengan tepat sisa waktu hingga ulang
                  tahun Anda berikutnya. Kalkulator bekerja secara otomatis dan memperbarui penghitung setiap
                  detik untuk menampilkan:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Jumlah bulan tersisa</li>
                  <li>Jumlah hari tersisa</li>
                  <li>Jumlah jam tersisa</li>
                  <li>Jumlah menit tersisa</li>
                  <li>Jumlah detik tersisa</li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Fitur Kalkulator:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Pembaruan Otomatis:</strong> Penghitung diperbarui setiap detik secara otomatis
                  </li>
                  <li>
                    <strong>Akurasi Tinggi:</strong> Perhitungan akurat hingga detik
                  </li>
                  <li>
                    <strong>Informasi Lengkap:</strong> Detail lengkap tentang ulang tahun Anda berikutnya
                  </li>
                  <li>
                    <strong>Mudah Digunakan:</strong> Antarmuka sederhana dan jelas
                  </li>
                  <li>
                    <strong>Notifikasi Khusus:</strong> Pesan ucapan selamat jika hari ini adalah ulang tahun Anda
                  </li>
                </ul>
                <div
                  className="alert alert-info mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>💡 Ide:</strong> Anda juga dapat menggunakan kalkulator untuk mengetahui berapa lama lagi
                  hingga ulang tahun orang yang Anda cintai!
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Mengapa Kita Merayakan Ulang Tahun?</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Ulang tahun adalah acara istimewa untuk merayakan hari kelahiran Anda dan berlalunya tahun baru
                  dalam hidup Anda. Merayakan ulang tahun memiliki banyak manfaat:
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Manfaat Psikologis:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Perasaan Dihargai:</strong> Perayaan membuat Anda merasa istimewa
                    dan dicintai
                  </li>
                  <li>
                    <strong>Meningkatkan Kepercayaan Diri:</strong> Hari khusus untuk Anda meningkatkan
                    rasa nilai diri Anda
                  </li>
                  <li>
                    <strong>Kenangan Indah:</strong> Menciptakan kenangan bahagia yang bertahan seumur hidup
                  </li>
                  <li>
                    <strong>Refleksi dan Evaluasi:</strong> Kesempatan untuk melihat apa yang telah Anda capai
                    dan merencanakan masa depan
                  </li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Manfaat Sosial:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Memperkuat Ikatan:</strong> Mengumpulkan orang-orang terkasih dan keluarga
                  </li>
                  <li>
                    <strong>Mengekspresikan Cinta:</strong> Kesempatan bagi orang lain untuk menunjukkan perhatian mereka
                  </li>
                  <li>
                    <strong>Tradisi Keluarga:</strong> Mewariskan kebiasaan dan tradisi kepada generasi
                  </li>
                  <li>
                    <strong>Momen Bahagia:</strong> Menciptakan suasana kegembiraan dan kebahagiaan
                  </li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Manfaat Perayaan:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Meningkatkan suasana hati dan kondisi psikologis</li>
                  <li>Memperkuat hubungan sosial</li>
                  <li>Menciptakan kenangan positif</li>
                  <li>Merasa bersyukur atas kehidupan</li>
                  <li>Kesempatan untuk perencanaan dan pengembangan diri</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Ide Kreatif untuk Merayakan Ulang Tahun</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  Perayaan Tradisional:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Pesta Rumahan:</strong> Mengundang teman dan keluarga ke rumah
                  </li>
                  <li>
                    <strong>Makan Malam di Restoran:</strong> Pilih restoran favorit Anda
                  </li>
                  <li>
                    <strong>Kue Ulang Tahun:</strong> Dapatkan kue istimewa dengan desain khusus
                  </li>
                  <li>
                    <strong>Hadiah:</strong> Menerima hadiah dari orang terkasih
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Ide Kreatif:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Perjalanan Singkat:</strong> Menghabiskan akhir pekan di tempat baru
                  </li>
                  <li>
                    <strong>Petualangan Baru:</strong> Mencoba aktivitas yang belum pernah Anda lakukan sebelumnya
                    (paralayang, menyelam, dll)
                  </li>
                  <li>
                    <strong>Hari Spa:</strong> Memanjakan diri dengan hari relaksasi penuh
                  </li>
                  <li>
                    <strong>Tindakan Amal:</strong> Menjadi sukarelawan atau berdonasi pada hari ulang tahun Anda
                  </li>
                  <li>
                    <strong>Pesta Bertema:</strong> Pesta kostum atau dengan tema khusus
                  </li>
                  <li>
                    <strong>Sesi Foto Profesional:</strong> Mengabadikan momen ini dengan foto-foto indah
                  </li>
                  <li>
                    <strong>Pengalaman Memasak:</strong> Lokakarya memasak atau menyiapkan hidangan khusus
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Perayaan Virtual (untuk pelancong atau dalam keadaan khusus):
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Pesta video online dengan orang terkasih yang jauh</li>
                  <li>Permainan kelompok online</li>
                  <li>Menonton film favorit dengan teman dari jarak jauh</li>
                  <li>Mengirim dan menerima hadiah digital</li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Perayaan untuk Anak-anak:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Pesta dengan karakter kartun</li>
                  <li>Permainan dan aktivitas hiburan</li>
                  <li>Pertunjukan sulap atau badut</li>
                  <li>Taman hiburan atau permainan</li>
                  <li>Lokakarya seni atau kerajinan</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Perencanaan Ulang Tahun Sejak Dini</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Perencanaan sejak dini memastikan perayaan yang sukses dan istimewa. Berikut panduan waktu
                  untuk persiapan:
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Sebulan Sebelum Ulang Tahun:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Tentukan jenis perayaan yang Anda inginkan</li>
                  <li>Buat daftar tamu undangan</li>
                  <li>Pilih tempat (rumah, restoran, aula, dll)</li>
                  <li>Tentukan anggaran</li>
                  <li>Mulai cari layanan yang diperlukan</li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Dua Minggu Sebelumnya:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Kirim undangan kepada tamu</li>
                  <li>Pesan tempat atau restoran</li>
                  <li>Pesan kue ulang tahun</li>
                  <li>Beli dekorasi</li>
                  <li>Rencanakan menu makanan</li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Seminggu Sebelumnya:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Konfirmasi pemesanan</li>
                  <li>Beli perlengkapan makanan</li>
                  <li>Siapkan daftar lagu favorit</li>
                  <li>Rencanakan aktivitas dan permainan</li>
                  <li>Pastikan jumlah peserta yang hadir</li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Sehari Sebelumnya:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Bersihkan tempat</li>
                  <li>Siapkan beberapa makanan sebelumnya</li>
                  <li>Atur dekorasi</li>
                  <li>Siapkan kamera untuk foto</li>
                  <li>Perhatikan penampilan pribadi Anda</li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Hari Ulang Tahun:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Atur dekorasi akhir</li>
                  <li>Siapkan makanan</li>
                  <li>Sambut tamu dengan hangat</li>
                  <li>Nikmati momennya dan jangan lupa mengambil foto!</li>
                </ul>
                <div
                  className="alert alert-success mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>✓ Tips Emas:</strong> Gunakan kalkulator hitungan mundur
                  untuk melacak sisa waktu dan mengatur persiapan Anda dengan lebih baik!
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Ulang Tahun di Seluruh Dunia</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Orang-orang merayakan ulang tahun dengan cara yang berbeda di seluruh dunia. Berikut beberapa
                  kebiasaan dan tradisi yang khas:
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Negara-negara Arab:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Mesir:</strong> Kue ulang tahun besar dan pertemuan keluarga
                  </li>
                  <li>
                    <strong>Arab Saudi:</strong> Perayaan keluarga dan hadiah untuk anak-anak
                  </li>
                  <li>
                    <strong>Lebanon:</strong> Pesta besar dan dekorasi mewah
                  </li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Negara-negara di Seluruh Dunia:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Meksiko:</strong> Tradisi "La Piñata" - memukul boneka yang digantung
                  </li>
                  <li>
                    <strong>Brasil:</strong> Menarik telinga yang berulang tahun sebanyak jumlah tahun
                  </li>
                  <li>
                    <strong>Cina:</strong> Makan mie panjang untuk umur panjang
                  </li>
                  <li>
                    <strong>Jepang:</strong> Merayakan ulang tahun tertentu saja (3, 5, 7)
                  </li>
                  <li>
                    <strong>Belanda:</strong> Kue khusus dan kursi yang dihias
                  </li>
                  <li>
                    <strong>Italia:</strong> Menarik telinga dan potongan kue pertama
                  </li>
                  <li>
                    <strong>Rusia:</strong> Kue pai sebagai pengganti kue tradisional
                  </li>
                  <li>
                    <strong>Kanada:</strong> Mengoleskan mentega di hidung yang berulang tahun untuk keberuntungan
                  </li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Kebiasaan yang Sama di Seluruh Dunia:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Memadamkan lilin di atas kue</li>
                  <li>Menyanyikan lagu ulang tahun</li>
                  <li>Memberikan hadiah</li>
                  <li>Mengambil foto kenangan</li>
                  <li>Berharap sebelum memadamkan lilin</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Tips untuk Membuat Ulang Tahun Anda Istimewa</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  Tips Umum:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Jujurlah pada diri sendiri:</strong> Rayakan dengan cara yang
                    sesuai untuk Anda, bukan dengan apa yang diharapkan orang lain
                  </li>
                  <li>
                    <strong>Mulai hitungan mundur lebih awal:</strong> Gunakan kalkulator kami
                    untuk melacak sisa waktu
                  </li>
                  <li>
                    <strong>Abadikan momen:</strong> Ambil banyak foto dan video
                  </li>
                  <li>
                    <strong>Bagikan kebahagiaan:</strong> Biarkan orang lain berbagi hari istimewa ini dengan Anda
                  </li>
                  <li>
                    <strong>Bersyukurlah:</strong> Hargai kehadiran orang-orang terkasih dalam hidup Anda
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Untuk Membuat Hari Anda Lebih Istimewa:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Mulailah hari dengan aktivitas yang Anda sukai</li>
                  <li>Kenakan pakaian yang membuat Anda percaya diri</li>
                  <li>Lakukan sesuatu yang baik untuk diri sendiri</li>
                  <li>Hubungi orang-orang penting dalam hidup Anda</li>
                  <li>Renungkan pencapaian Anda selama setahun terakhir</li>
                  <li>Tetapkan tujuan untuk tahun depan</li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Tips untuk Anggaran Terbatas:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Rayakan di rumah bersama keluarga</li>
                  <li>Buat kue sendiri</li>
                  <li>Gunakan dekorasi rumah sederhana</li>
                  <li>Mintalah tamu untuk berkontribusi pada makanan</li>
                  <li>Fokus pada suasana dan perasaan daripada penampilan</li>
                </ul>
                <div
                  className="alert alert-info mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>💝 Ingat:</strong> Yang terpenting dalam ulang tahun Anda adalah Anda
                  bahagia dan dikelilingi oleh orang yang Anda cintai!
                </div>
              </div>
            </div>
          </div>
          <br />
          <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>
            Pertanyaan Umum
          </h2>
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bagaimana cara mengetahui berapa lama lagi hingga ulang tahun saya?
                </h3>
              </div>
              <div className="info-section-body">
                Untuk mengetahui berapa lama lagi hingga ulang tahun Anda, ikuti langkah-langkah sederhana ini:
                <ol style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>Masukkan tanggal lahir Anda di kolom yang disediakan</li>
                  <li>Tekan tombol "Mulai Hitungan Mundur"</li>
                  <li>
                    Hasil akan langsung muncul dalam bulan, hari, jam, menit, dan detik
                  </li>
                  <li>
                    Penghitung akan diperbarui secara otomatis setiap detik untuk menampilkan sisa waktu dengan akurat
                  </li>
                </ol>
                Jika hari ini adalah ulang tahun Anda, pesan ucapan selamat khusus akan muncul!
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apakah penghitung diperbarui secara otomatis?
                </h3>
              </div>
              <div className="info-section-body">
                Ya, setelah Anda memulai hitungan mundur, penghitung diperbarui secara otomatis setiap
                detik tanpa perlu intervensi apa pun dari Anda. Ini berarti Anda akan melihat sisa waktu
                berkurang secara langsung di depan mata Anda, memberi Anda pengalaman hitungan mundur yang nyata
                dan menyenangkan. Anda dapat membiarkan halaman terbuka dan melihat penghitung bergerak secara terus-menerus!
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apa yang terjadi jika hari ini adalah ulang tahun saya?
                </h3>
              </div>
              <div className="info-section-body">
                Jika hari ini adalah ulang tahun Anda, pesan ucapan selamat khusus akan muncul dengan simbol
                perayaan (🎉 🎂). Pesan akan memberi tahu Anda usia baru Anda dan tanggal ulang tahun Anda
                berikutnya di tahun depan. Ini adalah cara yang bagus untuk memulai hari istimewa Anda dengan kejutan
                yang menyenangkan! Anda juga dapat mengambil tangkapan layar pesan untuk dibagikan dengan teman
                dan keluarga untuk merayakannya bersama mereka.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Dapatkah saya menggunakan kalkulator untuk ulang tahun orang lain?
                </h3>
              </div>
              <div className="info-section-body">
                Tentu saja! Anda dapat menggunakan kalkulator hitungan mundur ulang tahun untuk mengetahui
                berapa lama lagi hingga ulang tahun:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>Anak-anak Anda</li>
                  <li>Suami atau istri Anda</li>
                  <li>Orang tua Anda</li>
                  <li>Teman dekat Anda</li>
                  <li>Siapa pun yang ingin Anda rayakan ulang tahunnya</li>
                </ul>
                Ini adalah cara yang bagus untuk merencanakan perayaan terlebih dahulu dan memastikan Anda tidak akan pernah lupa
                ulang tahun orang yang Anda cintai!
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bagaimana cara memanfaatkan informasi hitungan mundur?
                </h3>
              </div>
              <div className="info-section-body">
                Informasi hitungan mundur sangat berguna untuk perencanaan awal:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    <strong>Jika tersisa satu bulan atau lebih:</strong> Mulailah merencanakan
                    perayaan, tentukan tempat, dan buat daftar tamu
                  </li>
                  <li>
                    <strong>Jika tersisa dua minggu:</strong> Kirim undangan, pesan restoran
                    atau aula, pesan kue
                  </li>
                  <li>
                    <strong>Jika tersisa satu minggu:</strong> Beli dekorasi
                    dan perlengkapan, konfirmasi pemesanan
                  </li>
                  <li>
                    <strong>Jika tersisa beberapa hari:</strong> Siapkan detail
                    terakhir, bersihkan tempat
                  </li>
                </ul>
                Gunakan kalkulator sebagai referensi untuk memastikan Anda berada di jalur yang benar dalam
                persiapan!
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apakah kalkulator ini akurat?
                </h3>
              </div>
              <div className="info-section-body">
                Ya, kalkulator hitungan mundur sangat akurat. Kalkulator menggunakan:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>Tanggal dan waktu saat ini dari perangkat Anda</li>
                  <li>Perhitungan akurat yang mempertimbangkan tahun kabisat</li>
                  <li>Pembaruan otomatis setiap detik</li>
                  <li>Persamaan pemrograman canggih</li>
                </ul>
                Akurasi dijamin hingga tingkat detik, sehingga Anda dapat mengandalkan hasilnya
                dengan keyakinan penuh. Penghitung menampilkan sisa waktu dengan sangat akurat dari saat ini
                hingga tengah malam pada hari ulang tahun Anda (pukul 00:00).
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Mengapa penting untuk mengetahui berapa lama lagi hingga ulang tahun?
                </h3>
              </div>
              <div className="info-section-body">
                Mengetahui sisa waktu hingga ulang tahun Anda penting karena beberapa alasan:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    <strong>Perencanaan awal:</strong> Memberi Anda cukup waktu
                    untuk persiapan
                  </li>
                  <li>
                    <strong>Motivasi:</strong> Menciptakan perasaan antisipasi dan kegembiraan
                  </li>
                  <li>
                    <strong>Tidak lupa:</strong> Mengingatkan Anda tentang acara penting
                  </li>
                  <li>
                    <strong>Berbagi:</strong> Anda dapat membagikan hitungan mundur dengan
                    orang lain
                  </li>
                  <li>
                    <strong>Pengaturan:</strong> Membantu Anda menjadwalkan persiapan dengan lebih baik
                  </li>
                </ul>
                Hitungan mundur menambahkan unsur kesenangan dan antisipasi untuk setiap perayaan!
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Dapatkah saya menyimpan hitungan mundur?
                </h3>
              </div>
              <div className="info-section-body">
                Anda dapat dengan mudah:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    <strong>Simpan halaman di favorit:</strong> Untuk kembali ke sana kapan saja
                  </li>
                  <li>
                    <strong>Ambil tangkapan layar:</strong> Untuk dibagikan dengan teman
                  </li>
                  <li>
                    <strong>Tambahkan halaman ke layar utama:</strong> Untuk kemudahan
                    akses di ponsel
                  </li>
                  <li>
                    <strong>Bagikan tautan kalkulator:</strong> Dengan orang yang Anda cintai untuk merayakan
                    bersama
                  </li>
                </ul>
                Kalkulator tersedia untuk Anda kapan saja dan dari perangkat apa pun, yang Anda butuhkan adalah memasukkan ulang
                tanggal lahir untuk memulai hitungan mundur dari awal.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AgeCalculatorGregorian;